import React, { useEffect, useState } from "react";
import {
  Box,
  Tab,
  TextField,
  Button,
  Grid,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useSelector, useDispatch } from "react-redux";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import Title from "../../components/ReusableComponents/title";
import {
  createCommissionDispatch,
  removeUserCommission,
} from "../../store/reducers/userProfileReducer";
import List from "./List";
import CommissionPayment from "./CommissionPayment";
import AffDashboard from "./Dashhboard";
import "./index.scss";
import Loader from "../../reusableComponents/Loader";
import CommissionSlider from "./CommissionSlider";

const AffiliateMarketing = () => {
  const dispatch = useDispatch();
  const { url, referalCode, aff_percentage_range } = useSelector(
    (state) => state.user
  );
  const [value, setValue] = useState("5");
  const [customCode, setCustomCode] = useState("");

  // Alert popup states
  const [ShowPopup, setShowPopup] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");
  const [Show, setShow] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(loader);
  useEffect(() => {
    setOpen(loader);
  }, [loader]);
  const handleChange = (event, newValue) => {
    event.preventDefault();
    setValue(newValue);
  };

  const [comValue, setComValue] = React.useState(9);
  const handleSubmit = () => {
    const payload = { percentage: comValue };
    if (customCode) {
      payload["code"] = customCode;
    }
    dispatch(createCommissionDispatch(payload))
      .then((res) => {
        if (res.status && res.status !== 200) {
          if (res.data.message) {
            setShowPopup(true);
            setCombinedPUHead("Oh snap!");
            setCombinedPUBody(res.data.message);
            setPopUpType("error");
            return;
          }
        }
      })
      .catch((err) => {
        console.log(err.response.data.detail);
        if (err.response.data.detail) {
          setShowPopup(true);
          setCombinedPUHead("Oh snap!");
          setCombinedPUBody(err.response.data.detail);
          setPopUpType("error");
        }
      });
  };

  const handleCross = () => {
    setShow(false);
  };

  return (
    <Grid
      className="ContainerTab affiliate-marketing"
      container
      p={1}
      style={{ position: "relative" }}
    >
      <Loader open={open} />
      <CombinedPopup
        type={PopUpType}
        trigger={ShowPopup}
        setTrigger={setShowPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
        setShow={setShow}
        onClick={handleCross}
      />
      <TabContext value={value}>
        <Box className="new-tabination-wrapper" sx={{ width: "100%" }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            className="newTabination affiliate-marketing-tabination"
          >
            <Tab
              className={
                activeTab === 0
                  ? "newTabination-item active"
                  : "newTabination-item"
              }
              label="Overview"
              value="5"
              onClick={() => setActiveTab(0)}
            />
            <Tab
              className={
                activeTab === 1
                  ? "newTabination-item active"
                  : "newTabination-item"
              }
              label="Get a Link"
              value="1"
              onClick={() => setActiveTab(1)}
            />
            <Tab
              className={
                activeTab === 2
                  ? "newTabination-item active"
                  : "newTabination-item"
              }
              label="Affiliate codes"
              value="2"
              onClick={() => setActiveTab(2)}
            />
            {/* <Tab
                            className="ContainertabName"
                            label="How it works"
                            value="3"
                        /> */}
            <Tab
              className={
                activeTab === 3
                  ? "newTabination-item active"
                  : "newTabination-item"
              }
              label="Commission Payment"
              value="4"
              onClick={() => setActiveTab(3)}
            />
          </TabList>
        </Box>
        <TabPanel
          style={{ padding: "0rem", marginTop: "10px", width: "100%" }}
          value="1"
        >
          <Box>
            <Box mb={3}>
              <Title three>NOTE:</Title>
              <Title three>
                {" "}
                1. Fixed Commission Income rate for alphacapital is{" "}
                {aff_percentage_range ? `${aff_percentage_range}%` : false}
              </Title>
              <Title three>
                {" "}
                2. Only user who signup with the below link can use the Unique
                Coupon Code as a Discount Coupon
              </Title>
            </Box>
            {referalCode ? (
              <Grid container spacing={5} style={{ marginTop: "1.1rem" }}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Title four Styles={{ marginBottom: "10px" }}>
                    {" "}
                    Your Unique Coupon Code
                  </Title>
                  <TextField
                    sx={{ border: "2px solid #293647", borderRadius: 1 }}
                    classes={{ marginTop: "20px", color: "white" }}
                    id="unique-code"
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <ContentCopyIcon
                            onClick={() =>
                              navigator.clipboard.writeText(referalCode)
                            }
                            sx={{ color: "#293647", cursor: "pointer" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    inputProps={{
                      style: { color: "white" },
                    }}
                    value={referalCode}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={5}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Title four Styles={{ marginBottom: "10px" }}>
                    {" "}
                    Your Affiliate link{" "}
                  </Title>
                  <TextField
                    id="affiliate-link-box"
                    variant="outlined"
                    sx={{
                      border: "2px solid #293647",
                      borderRadius: 1,
                      color: "#fff",
                    }}
                    inputProps={{
                      style: { color: "white", outline: "none" },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <ContentCopyIcon
                            onClick={() => navigator.clipboard.writeText(url)}
                            sx={{ color: "#293647", cursor: "pointer" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    value={url}
                  />
                </Grid>
              </Grid>
            ) : (
              false
            )}
            <Grid item xs={12}>
              <Grid
                className="affiliate-link"
                mt={3}
                style={{ textAlign: "left" }}
              >
                <Title four Styles={{ marginBottom: "10px" }}>
                  Choose Commission rate
                </Title>
                {/* <Slider
                                        min={0}
                                        max={aff_percentage_range}
                                        step={0.5}
                                        value={comValue}
                                        onChange={(value) => {
                                            setCustomCode("")
                                            setComValue(value)
                                            dispatch(removeUserCommission())
                                        }}
                                    /> */}
                <div
                  className="slider"
                  style={{
                    marginTop: "10px",
                    marginBottom: "20px",
                    marginLeft: "5px",
                    maxWidth: "400px",
                    backgroundColor: "EF5350",
                  }}
                >
                  {aff_percentage_range ? (
                    <CommissionSlider
                      min={0}
                      max={aff_percentage_range}
                      value={comValue}
                      onChange={(value) => {
                        setCustomCode("");
                        setComValue(value);
                        dispatch(removeUserCommission());
                      }}
                    />
                  ) : (
                    false
                  )}
                  <br />
                  <div
                    className="d-flex"
                    style={{ gap: "3rem", flexWrap: "wrap" }}
                  >
                    <div>
                      <Title two>{comValue} %</Title>
                      <Title
                        three
                        styles={{ textAlign: "center", color: "#8B8E93" }}
                      >
                        Your Commission
                        <Tooltip
                          enterTouchDelay={0}
                          title={
                            <React.Fragment>
                              <Title seven>
                                Commission you'll receive when the consumer uses
                                the affiliate code as a discount coupon.
                              </Title>
                            </React.Fragment>
                          }
                        >
                          <span
                            style={{
                              color: "#1e88e5",
                              fontSize: "0.8rem",
                              margin: "0px 5px",
                            }}
                          >
                            info
                          </span>
                        </Tooltip>
                      </Title>
                    </div>
                    {/* <br/> */}
                    <div>
                      <Title two>
                        {aff_percentage_range
                          ? aff_percentage_range - comValue
                          : false}{" "}
                        %
                      </Title>
                      <Title
                        three
                        styles={{ textAlign: "center", color: "#8B8E93" }}
                      >
                        Unique Code Discount
                        <Tooltip
                          enterTouchDelay={0}
                          title={
                            <React.Fragment>
                              <Title seven>
                                Discount that the customer can use to make
                                purchases using the affiliate code as a coupon
                              </Title>
                            </React.Fragment>
                          }
                        >
                          <span
                            style={{
                              color: "#1e88e5",
                              fontSize: "0.8rem",
                              margin: "0px 5px",
                            }}
                          >
                            info
                          </span>
                        </Tooltip>
                      </Title>
                    </div>
                  </div>
                </div>

                {referalCode ? (
                  false
                ) : (
                  <Grid
                    item
                    className="unique-code-container"
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Title four Styles={{ marginBottom: "10px" }}>
                      Custom Code?
                    </Title>
                    <TextField
                      sx={{
                        border: "2px solid #293647",
                        borderRadius: 15,
                        maxWidth: "320px",
                        marginBottom: "20px",
                      }}
                      classes={{ marginTop: "20px", color: "white" }}
                      id="custom-code"
                      variant="outlined"
                      placeholder="Enter an unique code"
                      onChange={(e) => {
                        e.preventDefault();
                        setCustomCode(e.target.value);
                      }}
                      inputProps={{
                        style: { color: "white" },
                      }}
                      value={customCode}
                    />
                  </Grid>
                )}

                <Button
                className="unique-code-generate-button"
                  variant="contained"
                  onClick={handleSubmit}
                  style={{
                    padding: "10px 50px",
                    borderRadius: "15px",
                    textTransform: "capitalize",
                  }}
                >
                  Generate
                </Button>
              </Grid>
            </Grid>
          </Box>
        </TabPanel>
        <TabPanel
          style={{ padding: "1rem", marginTop: "10px", width: "100%" }}
          value="2"
          className="affiliate-code-table"
        >
          <Box>
            <List />
          </Box>
        </TabPanel>
        <TabPanel
        className="commission-payment-table"
          style={{ padding: "0rem", marginTop: "10px", width: "100%" }}
          value="4"
        >
          <CommissionPayment />
        </TabPanel>
        <TabPanel
          className="aff-dashboard"
          style={{ padding: "0rem", marginTop: "10px", width: "100%" }}
          value="5"
        >
          <Box>
            <AffDashboard />
          </Box>
        </TabPanel>
      </TabContext>
    </Grid>
  );
};

export default AffiliateMarketing;
